import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

const GetRequests = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null || value === undefined) return;
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/requests`;
    if (params.toString()) url += `?${params.toString()}`;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const GetRequestById = async (id) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}`;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const SearchRequest = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) {
            params.append(key, value);
            paramCount++;
        }
    });

    let url = `${config.API_URL}/requests/search`;
    if (paramCount > 0) {
        url += `?${params.toString()}`;
    }

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const SearchRequestDashboard = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null || value === undefined) return;
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/requests`;
    if (params.toString()) url += `?${params.toString()}`;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const CreateRequest = async (req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

// ── FIX: เปลี่ยนจาก apiClient.put เป็น apiClient.patch ──
// ── endpoint เดิมใช้ PUT (ต้องส่งข้อมูลทั้ง object) เปลี่ยนเป็น PATCH (partial update) ให้สอดคล้องกับ PatchRequest ด้านล่าง ──
const UpdateRequest = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.patch(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const AssignMessengerRequest = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/assign`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const ChangeStateRequest = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/change-state`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const DuplicateRequests = async (req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/duplicates/manual`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const PatchRequest = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.patch(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const ChangeWorkflowStatus = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/change-workflow-status`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const PatchRequestDetail = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/request-details/${id}`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.patch(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const ReassignMessengerRequest = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/reassign`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const GetRequestDetails = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null || value === undefined) return;
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/request-details`;
    if (params.toString()) url += `?${params.toString()}`;

    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

// const SendEmail = async (requestId, emailType) => {
//     const token = await getAccessToken();
//     const url = `${config.API_URL}/emails/requests/send`;

//     const formData = new FormData();
//     formData.append('id_request', String(requestId));
//     formData.append('type', emailType);

//     const headers = {
//         Authorization: `Bearer ${token}`,
//         User: getUserEmail(),
//     };

//     try {
//         return await apiClient.post(url, formData, { headers, timeout: config.API_CONNECTION_TIMEOUT });
//     } catch (error) { throw error; }
// };


const SearchRequestWorkflows = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null) return;
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    });

    const url = `${config.API_URL}/request-workflows/search?${params.toString()}`;
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const DeleteRequestRecurring = async (id) => {
    const token = await getAccessToken();
    const url = `${config.API_URL}/request-recurrings/${id}`;
    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };
    try {
        return await apiClient.delete(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

// ── Messenger task flow (ใหม่) ───────────────────────────────
// ปุ่ม "เริ่มส่งงาน" — เปลี่ยน wf 5/9→6 และเซ็ต send_start_date ของ task แรกที่ยังไม่เสร็จ
const StartTask = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/task/start`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

// ปุ่ม "ส่งสำเร็จ" — เซ็ต send_end_date, is_complete=1 ของ task นี้
const CompleteTask = async (id, idTask, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/task/${idTask}/complete`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

// ปุ่ม "ขอจบงาน" — เซ็ต send_end_date, is_complete=0, บันทึก close reason, เปลี่ยน wf เป็น INCOMPLETE
const CloseTask = async (id, idTask, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/requests/${id}/task/${idTask}/close`;

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const RequestService = {
    GetRequests,
    GetRequestById,
    SearchRequest,
    SearchRequestDashboard,
    CreateRequest,
    UpdateRequest,
    PatchRequest,
    AssignMessengerRequest,
    ChangeStateRequest,
    ChangeWorkflowStatus,
    DuplicateRequests,
    PatchRequestDetail,
    ReassignMessengerRequest,
    GetRequestDetails,
    // SendEmail,
    SearchRequestWorkflows,
    DeleteRequestRecurring,
    StartTask,
    CompleteTask,
    CloseTask,
};

export default RequestService;